import React from 'react';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { LazyImage } from '@/components/ui/LazyImage';

export function ImageBanner() {
  const { t } = useTranslation();
  return (
    <section className="relative w-full h-[60vh] min-h-[400px] border-y border-ground-deep bg-gradient-to-br from-ink to-ink/80 overflow-hidden">
      <motion.div 
        initial={{ scale: 1.05 }}
        whileInView={{ scale: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        viewport={{ once: true }}
        className="absolute inset-0"
      >
        <LazyImage 
          src="/five_lens_team_effectiveness_hero_web.webp"
          alt="Executive team in a modern office working together on team alignment and collaboration"
          className="w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent mix-blend-multiply" />
      </motion.div>
      
      <div className="absolute inset-0 flex items-center justify-center p-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
          className="max-w-3xl"
        >
          <div className="mb-6 flex items-center justify-center gap-3">
            <span className="h-[1px] w-8 bg-rule-3"></span>
            <span className="text-[11px] uppercase tracking-[0.3em] font-bold text-rule-3">
              {t('banner.eyebrow', 'Collaborative Intelligence')}
            </span>
            <span className="h-[1px] w-8 bg-rule-3"></span>
          </div>
          <h2 className="text-4xl md:text-5xl font-serif leading-tight text-white mb-6 font-normal">
            {t('banner.title', 'Aligning executive teams for sustainable success.')}
          </h2>
        </motion.div>
      </div>
    </section>
  );
}
